import StoreCouponsPage from 'components/pages/Store';

import getServerDateProps from 'lib/date/getServerDateProps';
import { toStoreOffersLink } from 'lib/links';
import { toSidebarFeaturedOffers } from 'lib/offer';
import { resolvify } from 'lib/promises';

import { getActiveAdsByStore, getAds } from 'services/ads';
import { getCategoriesList } from 'services/category';
import { getLandingsList } from 'services/landing';
import { getFeaturedOffersList, getOfferInfo } from 'services/offer';
import { getSuggestedSearchKeywordsList } from 'services/search';
import {
  getPopularStoresListWithOffersCount,
  getStoreCouponsList,
  getStoreInfo,
  getStoreOffersList,
  getStoresList,
} from 'services/store';

import APP from 'constants/app';
import LINKS from 'constants/links';
import STORES from 'constants/store';

const OFFERS_SERVER_LIMIT = 24;
const MERCADO_LIVRE_FIXED_OFFER_ID = 2059843;

const StoreOffers = (props) => <StoreCouponsPage {...props} />;

export const getServerSideProps = async ({ params: { storeSlug } }) => {
  /**
   * This resolves the retroactive of some 404 errors when some slugs going
   * with unwanted whitespaces.
   */
  if (!storeSlug || storeSlug.trim() !== storeSlug) {
    return {
      redirect: { destination: toStoreOffersLink(storeSlug), permanent: true },
    };
  }

  const meliuzbit = 0;

  try {
    const [
      store,
      serverOffers,
      { recommendedOffers },
      featuredOffers,
      popularStores,
      couponsByStore,
      storeAd,
      categories,
      stores,
      featuredLandings,
      highlightedLandings,
      {
        data: {
          topAd: [topbarAd = null],
          topbarHighlight: navbarAds,
        },
      },
      fixedOffer,
    ] = await resolvify([
      getStoreInfo({ storeSlug }),
      getStoreOffersList({
        limit:
          storeSlug === STORES.MERCADO_LIVRE_STORE_SLUG
            ? STORES.MERCADO_LIVRE_OFFERS_SERVER_LIMIT
            : OFFERS_SERVER_LIMIT,
        storeSlug,
      }),
      {
        fn: getSuggestedSearchKeywordsList({ withOffers: true }),
        fallback: { recommendedOffers: [] },
      },
      { fn: getFeaturedOffersList(), fallback: getFeaturedOffersList.fallback },
      getPopularStoresListWithOffersCount({
        limit: STORES.POPULAR_STORES_LIMIT,
      }),
      getStoreCouponsList({ storeSlug }),
      {
        fn: getActiveAdsByStore({ storeSlug }),
        fallback: getActiveAdsByStore.fallback,
      },
      {
        fn: getCategoriesList({ selectedCategories: true }),
        fallback: getCategoriesList.fallback,
      },
      {
        fn: getStoresList({ from: 'topbar' }),
        fallback: getStoresList.fallback,
      },
      {
        fn: getLandingsList({ featured: true }),
        fallback: getLandingsList.fallback,
      },
      {
        fn: getLandingsList({ highlighted: true }),
        fallback: getLandingsList.fallback,
      },
      {
        fn: getAds(),
        fallback: getAds.fallback,
      },
      {
        fn: getOfferInfo({ offerId: MERCADO_LIVRE_FIXED_OFFER_ID, meliuzbit }),
        fallback: null,
        enabled: storeSlug === STORES.MERCADO_LIVRE_STORE_SLUG,
      },
    ]);

    const sidebarFeaturedOffers = toSidebarFeaturedOffers(
      recommendedOffers,
      featuredOffers
    );

    return {
      props: {
        ...getServerDateProps(),
        couponsByStore: couponsByStore?.coupons.slice(0, 3) || [],
        popularStores: popularStores || [],
        serverCoupons: couponsByStore,
        serverOffers,
        sidebarFeaturedOffers,
        store,
        storeAd,
        [APP.CTX_OPTIONAL_PROPS]: {
          categories,
          featuredLandings,
          highlightedLandings,
          navbarAds,
          stores,
          topbarAd,
        },
        fixedOffer,
      },
    };
  } catch {
    return { redirect: { destination: LINKS[404], permanent: false } };
  }
};

export default StoreOffers;
